import { WSO2_LOGOUT_URL } from "../constants/API";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "../constants/interfaces";
import { userTypes } from "./user";
import { removeBeforeunloadListener } from "../components/navigation/OnBeforeUnload";
import api from "../utils/api";

interface State {
  error: Error | null;
  loading: boolean;
  token: string | null;
}

export function getInitialState(): State {
  return {
    token: window.localStorage.getItem("token"),
    loading: false,
    error: null
  };
}

export const authTypes = {
  GET_USER_PRINCIPAL_REQUEST: "GET_USER_PRINCIPAL_REQUEST",
  GET_USER_PRINCIPAL_RESPONSE: "GET_USER_PRINCIPAL_RESPONSE",
  LOGOUT_USER_REQUEST: "LOGOUT_USER_REQUEST",
  LOGOUT_USER_RESPONSE: "LOGOUT_USER_RESPONSE",
  SET_TOKEN: "SET_TOKEN"
};

export const authActions: any = {
  // Gets authenticated user principal from WS02
  getUserPrincipal: () => async (
    dispatch: ThunkDispatch<{}, {}, AnyAction>
  ) => {
    dispatch({ type: authTypes.GET_USER_PRINCIPAL_REQUEST });
    try {
      const { data: user } = await api.get("/user/me");

      dispatch({
        type: authTypes.GET_USER_PRINCIPAL_RESPONSE,
        error: false
      });
      dispatch({
        type: userTypes.UPDATE_USER_DETAILS_RESPONSE,
        payload: user,
        error: false
      });
    } catch (e) {
      dispatch({
        type: authTypes.GET_USER_PRINCIPAL_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  },

  setToken: (token: string) => (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    try {
      window.localStorage.setItem("token", token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      dispatch({
        type: authTypes.SET_TOKEN,
        payload: token,
        error: false
      });
    } catch (e) {
      dispatch({ type: authTypes.SET_TOKEN, payload: e, error: true });
      return e;
    }
  },

  logoutUser: () => async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch({ type: authTypes.LOGOUT_USER_REQUEST });
    try {
      window.localStorage.removeItem("token");
      api.defaults.headers.common["Authorization"] = null;
      dispatch({
        type: authTypes.LOGOUT_USER_RESPONSE,
        error: false
      });
      removeBeforeunloadListener();
      window.location.href = WSO2_LOGOUT_URL;
    } catch (e) {
      dispatch({
        type: authTypes.LOGOUT_USER_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  }
};

export default function auth(state = getInitialState(), action: Action) {
  const { type, payload, error } = action;
  switch (type) {
    case authTypes.GET_USER_PRINCIPAL_REQUEST: {
      return { ...state, loading: true, error: null };
    }

    case authTypes.GET_USER_PRINCIPAL_RESPONSE: {
      if (error) {
        // If something goes wrong, do not authenticate user
        return { ...state, loading: false, error: payload };
      }
      return {
        ...state,
        loading: false,
        error: null
      };
    }

    case authTypes.LOGOUT_USER_REQUEST: {
      return { ...state, loading: true, error: null };
    }

    case authTypes.LOGOUT_USER_RESPONSE: {
      if (error) {
        return {
          ...state,
          loading: false,
          error: payload,
          token: null,
          user: null
        };
      }
      return { ...state, loading: false, error: null, token: null, user: null };
    }

    case authTypes.SET_TOKEN: {
      if (error) {
        return { ...state, loading: false, error: payload, token: null };
      }
      return { ...state, loading: false, error: null, token: payload };
    }
  }
  return state;
}
